import type { ReactElement } from 'react';
import { projectContextResourceWithCache } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { useResource } from '@atlassian/react-resource-router';

export type Props = {
	children: (arg1: ProjectContext) => ReactElement;
};

/**
 * Listens for ProjectContext data to be fetched by projectContextResource.
 * returns Props with ProjectContext data from projectContextResourceWithCache
 * returns null if projectKey and projectId not found (i.e. children are not returned)`
 */
export const ProjectContextSubscriber = ({ children }: Props) => {
	const { data } = useResource(projectContextResourceWithCache);
	if (!data) return null;
	return children(data);
};
